/* tslint:disable */
/* eslint-disable */
/**
 * member-directory
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface BaseMemberDetails
 */
export interface BaseMemberDetails {
    /**
     * 
     * @type {string}
     * @memberof BaseMemberDetails
     */
    'email_address': string;
    /**
     * 
     * @type {MemberName}
     * @memberof BaseMemberDetails
     */
    'name'?: MemberName | null;
    /**
     * 
     * @type {ShippingAddress}
     * @memberof BaseMemberDetails
     */
    'shipping_address'?: ShippingAddress | null;
    /**
     * 
     * @type {string}
     * @memberof BaseMemberDetails
     */
    'date_of_birth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BaseMemberDetails
     */
    'order_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BaseMemberDetails
     */
    'sex'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BaseMemberDetails
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BaseMemberDetails
     */
    'phone_number'?: string | null;
}
/**
 * 
 * @export
 * @interface FirstNameUpdate
 */
export interface FirstNameUpdate {
    /**
     * 
     * @type {string}
     * @memberof FirstNameUpdate
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof FirstNameUpdate
     */
    'updated_by': string;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface LocationInner
 */
export interface LocationInner {
}
/**
 * 
 * @export
 * @interface MemberCreate
 */
export interface MemberCreate {
    /**
     * 
     * @type {string}
     * @memberof MemberCreate
     */
    'email_address': string;
    /**
     * 
     * @type {MemberName}
     * @memberof MemberCreate
     */
    'name'?: MemberName | null;
    /**
     * 
     * @type {ShippingAddress}
     * @memberof MemberCreate
     */
    'shipping_address'?: ShippingAddress | null;
    /**
     * 
     * @type {string}
     * @memberof MemberCreate
     */
    'date_of_birth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberCreate
     */
    'order_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberCreate
     */
    'sex'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberCreate
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberCreate
     */
    'phone_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberCreate
     */
    'username'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MemberCreate
     */
    'validate_unique_email'?: boolean | null;
}
/**
 * 
 * @export
 * @interface MemberDetails
 */
export interface MemberDetails {
    /**
     * 
     * @type {string}
     * @memberof MemberDetails
     */
    'email_address': string;
    /**
     * 
     * @type {MemberName}
     * @memberof MemberDetails
     */
    'name'?: MemberName | null;
    /**
     * 
     * @type {ShippingAddress}
     * @memberof MemberDetails
     */
    'shipping_address'?: ShippingAddress | null;
    /**
     * 
     * @type {string}
     * @memberof MemberDetails
     */
    'date_of_birth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberDetails
     */
    'order_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberDetails
     */
    'sex'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberDetails
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberDetails
     */
    'phone_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberDetails
     */
    'username'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberDetails
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MemberDetails
     */
    'created_at'?: string | null;
}
/**
 * 
 * @export
 * @interface MemberDetailsIn
 */
export interface MemberDetailsIn {
    /**
     * 
     * @type {string}
     * @memberof MemberDetailsIn
     */
    'email_address': string;
    /**
     * 
     * @type {MemberName}
     * @memberof MemberDetailsIn
     */
    'name'?: MemberName | null;
    /**
     * 
     * @type {ShippingAddress}
     * @memberof MemberDetailsIn
     */
    'shipping_address'?: ShippingAddress | null;
    /**
     * 
     * @type {string}
     * @memberof MemberDetailsIn
     */
    'date_of_birth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberDetailsIn
     */
    'order_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberDetailsIn
     */
    'sex'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberDetailsIn
     */
    'gender'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberDetailsIn
     */
    'phone_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberDetailsIn
     */
    'username'?: string | null;
}
/**
 * 
 * @export
 * @interface MemberDetailsUpdate
 */
export interface MemberDetailsUpdate {
    /**
     * 
     * @type {MemberName}
     * @memberof MemberDetailsUpdate
     */
    'name'?: MemberName | null;
    /**
     * 
     * @type {ShippingAddress}
     * @memberof MemberDetailsUpdate
     */
    'shipping_address'?: ShippingAddress | null;
    /**
     * 
     * @type {string}
     * @memberof MemberDetailsUpdate
     */
    'phone_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MemberDetailsUpdate
     */
    'updated_by': string;
}
/**
 * 
 * @export
 * @interface MemberIdList
 */
export interface MemberIdList {
    /**
     * 
     * @type {Array<string>}
     * @memberof MemberIdList
     */
    'ids': Array<string>;
}
/**
 * 
 * @export
 * @interface MemberName
 */
export interface MemberName {
    /**
     * 
     * @type {string}
     * @memberof MemberName
     */
    'first_name': string;
    /**
     * 
     * @type {string}
     * @memberof MemberName
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof MemberName
     */
    'full_name': string;
}
/**
 * 
 * @export
 * @interface MemberRecord
 */
export interface MemberRecord {
    /**
     * 
     * @type {RevisionDetails}
     * @memberof MemberRecord
     */
    'revision': RevisionDetails;
    /**
     * 
     * @type {MemberDetails}
     * @memberof MemberRecord
     */
    'details': MemberDetails;
}
/**
 * 
 * @export
 * @interface MemberSearchIn
 */
export interface MemberSearchIn {
    /**
     * 
     * @type {string}
     * @memberof MemberSearchIn
     */
    'search': string;
}
/**
 * 
 * @export
 * @interface MemberSearchOut
 */
export interface MemberSearchOut {
    /**
     * 
     * @type {Array<string>}
     * @memberof MemberSearchOut
     */
    'member_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface MemberUpdate
 */
export interface MemberUpdate {
    /**
     * 
     * @type {number}
     * @memberof MemberUpdate
     */
    'expected_revision': number;
    /**
     * 
     * @type {string}
     * @memberof MemberUpdate
     */
    'updated_by': string;
    /**
     * 
     * @type {MemberDetailsIn}
     * @memberof MemberUpdate
     */
    'details': MemberDetailsIn;
    /**
     * 
     * @type {boolean}
     * @memberof MemberUpdate
     */
    'validate_unique_email'?: boolean | null;
}
/**
 * 
 * @export
 * @interface MemberUsernameList
 */
export interface MemberUsernameList {
    /**
     * 
     * @type {Array<string>}
     * @memberof MemberUsernameList
     */
    'usernames': Array<string>;
}
/**
 * 
 * @export
 * @interface PartialShippingAddress
 */
export interface PartialShippingAddress {
    /**
     * 
     * @type {string}
     * @memberof PartialShippingAddress
     */
    'line1': string;
    /**
     * 
     * @type {string}
     * @memberof PartialShippingAddress
     */
    'postal_code': string;
    /**
     * 
     * @type {string}
     * @memberof PartialShippingAddress
     */
    'country_code': string;
}
/**
 * 
 * @export
 * @interface RevisionDetails
 */
export interface RevisionDetails {
    /**
     * 
     * @type {number}
     * @memberof RevisionDetails
     */
    'revision': number;
    /**
     * 
     * @type {string}
     * @memberof RevisionDetails
     */
    'revision_created_at': string;
    /**
     * 
     * @type {string}
     * @memberof RevisionDetails
     */
    'revision_created_by': string;
}
/**
 * 
 * @export
 * @interface ShippingAddress
 */
export interface ShippingAddress {
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'line1': string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'line2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'province': string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'province_code': string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'postal_code': string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof ShippingAddress
     */
    'country_code': string;
}
/**
 * 
 * @export
 * @interface UserRecord
 */
export interface UserRecord {
    /**
     * 
     * @type {string}
     * @memberof UserRecord
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserRecord
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof UserRecord
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof UserRecord
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<LocationInner>}
     * @memberof ValidationError
     */
    'loc': Array<LocationInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}

/**
 * MembersApi - axios parameter creator
 * @export
 */
export const MembersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Publish MemberCreatedOrUpdated events for each member specified in the request body.
         * @summary Bulk Publish User Details
         * @param {MemberUsernameList} memberUsernameList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkPublishUserDetails: async (memberUsernameList: MemberUsernameList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberUsernameList' is not null or undefined
            assertParamExists('bulkPublishUserDetails', 'memberUsernameList', memberUsernameList)
            const localVarPath = `/members/publish/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memberUsernameList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Or Update Member
         * @param {MemberCreate} memberCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateMember: async (memberCreate: MemberCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberCreate' is not null or undefined
            assertParamExists('createOrUpdateMember', 'memberCreate', memberCreate)
            const localVarPath = `/members/v2/create_or_update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memberCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Latest Member Revision For Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestMemberRevisionForUsername: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getLatestMemberRevisionForUsername', 'username', username)
            const localVarPath = `/members/username/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Member By Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberByEmail: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getMemberByEmail', 'email', email)
            const localVarPath = `/members/email/{email}`
                .replace(`{${"email"}}`, encodeURIComponent(String(email)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Member Current Revision
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberCurrentRevision: async (memberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getMemberCurrentRevision', 'memberId', memberId)
            const localVarPath = `/members/{member_id}`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Member Specific Revision
         * @param {string} memberId 
         * @param {number} revisionNb 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberSpecificRevision: async (memberId: string, revisionNb: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('getMemberSpecificRevision', 'memberId', memberId)
            // verify required parameter 'revisionNb' is not null or undefined
            assertParamExists('getMemberSpecificRevision', 'revisionNb', revisionNb)
            const localVarPath = `/members/{member_id}/revisions/{revision_nb}`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)))
                .replace(`{${"revision_nb"}}`, encodeURIComponent(String(revisionNb)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Members With Shipping Address
         * @param {PartialShippingAddress} partialShippingAddress 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembersWithShippingAddress: async (partialShippingAddress: PartialShippingAddress, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'partialShippingAddress' is not null or undefined
            assertParamExists('getMembersWithShippingAddress', 'partialShippingAddress', partialShippingAddress)
            const localVarPath = `/members/address/list_members_by_address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(partialShippingAddress, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Member Revisions
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberRevisions: async (memberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('listMemberRevisions', 'memberId', memberId)
            const localVarPath = `/members/{member_id}/revisions/`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Members By Ids
         * @param {MemberIdList} memberIdList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembersByIds: async (memberIdList: MemberIdList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberIdList' is not null or undefined
            assertParamExists('listMembersByIds', 'memberIdList', memberIdList)
            const localVarPath = `/members/list_members_by_ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memberIdList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Members By Usernames
         * @param {MemberUsernameList} memberUsernameList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembersByUsernames: async (memberUsernameList: MemberUsernameList, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberUsernameList' is not null or undefined
            assertParamExists('listMembersByUsernames', 'memberUsernameList', memberUsernameList)
            const localVarPath = `/members/username/list_members_by_username`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memberUsernameList, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Park Email
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkEmail: async (memberId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('parkEmail', 'memberId', memberId)
            const localVarPath = `/members/{member_id}/park_email`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for members based on username (exact match) or email address or full name (case-insensitive substring match).
         * @summary Search
         * @param {MemberSearchIn} memberSearchIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (memberSearchIn: MemberSearchIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberSearchIn' is not null or undefined
            assertParamExists('search', 'memberSearchIn', memberSearchIn)
            const localVarPath = `/members/v2/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memberSearchIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Member Details
         * @param {string} memberId 
         * @param {MemberUpdate} memberUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberDetails: async (memberId: string, memberUpdate: MemberUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('updateMemberDetails', 'memberId', memberId)
            // verify required parameter 'memberUpdate' is not null or undefined
            assertParamExists('updateMemberDetails', 'memberUpdate', memberUpdate)
            const localVarPath = `/members/{member_id}`
                .replace(`{${"member_id"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memberUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MembersApi - functional programming interface
 * @export
 */
export const MembersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MembersApiAxiosParamCreator(configuration)
    return {
        /**
         * Publish MemberCreatedOrUpdated events for each member specified in the request body.
         * @summary Bulk Publish User Details
         * @param {MemberUsernameList} memberUsernameList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkPublishUserDetails(memberUsernameList: MemberUsernameList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkPublishUserDetails(memberUsernameList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembersApi.bulkPublishUserDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Or Update Member
         * @param {MemberCreate} memberCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdateMember(memberCreate: MemberCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdateMember(memberCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembersApi.createOrUpdateMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Latest Member Revision For Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestMemberRevisionForUsername(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestMemberRevisionForUsername(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembersApi.getLatestMemberRevisionForUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Member By Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberByEmail(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberByEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembersApi.getMemberByEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Member Current Revision
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberCurrentRevision(memberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberCurrentRevision(memberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembersApi.getMemberCurrentRevision']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Member Specific Revision
         * @param {string} memberId 
         * @param {number} revisionNb 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberSpecificRevision(memberId: string, revisionNb: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberSpecificRevision(memberId, revisionNb, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembersApi.getMemberSpecificRevision']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Members With Shipping Address
         * @param {PartialShippingAddress} partialShippingAddress 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMembersWithShippingAddress(partialShippingAddress: PartialShippingAddress, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberRecord>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMembersWithShippingAddress(partialShippingAddress, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembersApi.getMembersWithShippingAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Member Revisions
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMemberRevisions(memberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RevisionDetails>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMemberRevisions(memberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembersApi.listMemberRevisions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Members By Ids
         * @param {MemberIdList} memberIdList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMembersByIds(memberIdList: MemberIdList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberRecord>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMembersByIds(memberIdList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembersApi.listMembersByIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Members By Usernames
         * @param {MemberUsernameList} memberUsernameList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMembersByUsernames(memberUsernameList: MemberUsernameList, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MemberRecord>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMembersByUsernames(memberUsernameList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembersApi.listMembersByUsernames']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Park Email
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async parkEmail(memberId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.parkEmail(memberId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembersApi.parkEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search for members based on username (exact match) or email address or full name (case-insensitive substring match).
         * @summary Search
         * @param {MemberSearchIn} memberSearchIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(memberSearchIn: MemberSearchIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberSearchOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(memberSearchIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembersApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Member Details
         * @param {string} memberId 
         * @param {MemberUpdate} memberUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMemberDetails(memberId: string, memberUpdate: MemberUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMemberDetails(memberId, memberUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MembersApi.updateMemberDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MembersApi - factory interface
 * @export
 */
export const MembersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MembersApiFp(configuration)
    return {
        /**
         * Publish MemberCreatedOrUpdated events for each member specified in the request body.
         * @summary Bulk Publish User Details
         * @param {MemberUsernameList} memberUsernameList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkPublishUserDetails(memberUsernameList: MemberUsernameList, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.bulkPublishUserDetails(memberUsernameList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Or Update Member
         * @param {MemberCreate} memberCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdateMember(memberCreate: MemberCreate, options?: RawAxiosRequestConfig): AxiosPromise<MemberRecord> {
            return localVarFp.createOrUpdateMember(memberCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Latest Member Revision For Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestMemberRevisionForUsername(username: string, options?: RawAxiosRequestConfig): AxiosPromise<MemberRecord> {
            return localVarFp.getLatestMemberRevisionForUsername(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Member By Email
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberByEmail(email: string, options?: RawAxiosRequestConfig): AxiosPromise<MemberRecord> {
            return localVarFp.getMemberByEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Member Current Revision
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberCurrentRevision(memberId: string, options?: RawAxiosRequestConfig): AxiosPromise<MemberRecord> {
            return localVarFp.getMemberCurrentRevision(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Member Specific Revision
         * @param {string} memberId 
         * @param {number} revisionNb 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberSpecificRevision(memberId: string, revisionNb: number, options?: RawAxiosRequestConfig): AxiosPromise<MemberRecord> {
            return localVarFp.getMemberSpecificRevision(memberId, revisionNb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Members With Shipping Address
         * @param {PartialShippingAddress} partialShippingAddress 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembersWithShippingAddress(partialShippingAddress: PartialShippingAddress, options?: RawAxiosRequestConfig): AxiosPromise<Array<MemberRecord>> {
            return localVarFp.getMembersWithShippingAddress(partialShippingAddress, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Member Revisions
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMemberRevisions(memberId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RevisionDetails>> {
            return localVarFp.listMemberRevisions(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Members By Ids
         * @param {MemberIdList} memberIdList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembersByIds(memberIdList: MemberIdList, options?: RawAxiosRequestConfig): AxiosPromise<Array<MemberRecord>> {
            return localVarFp.listMembersByIds(memberIdList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Members By Usernames
         * @param {MemberUsernameList} memberUsernameList 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMembersByUsernames(memberUsernameList: MemberUsernameList, options?: RawAxiosRequestConfig): AxiosPromise<Array<MemberRecord>> {
            return localVarFp.listMembersByUsernames(memberUsernameList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Park Email
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parkEmail(memberId: string, options?: RawAxiosRequestConfig): AxiosPromise<MemberRecord> {
            return localVarFp.parkEmail(memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * Search for members based on username (exact match) or email address or full name (case-insensitive substring match).
         * @summary Search
         * @param {MemberSearchIn} memberSearchIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(memberSearchIn: MemberSearchIn, options?: RawAxiosRequestConfig): AxiosPromise<MemberSearchOut> {
            return localVarFp.search(memberSearchIn, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Member Details
         * @param {string} memberId 
         * @param {MemberUpdate} memberUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberDetails(memberId: string, memberUpdate: MemberUpdate, options?: RawAxiosRequestConfig): AxiosPromise<MemberRecord> {
            return localVarFp.updateMemberDetails(memberId, memberUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MembersApi - object-oriented interface
 * @export
 * @class MembersApi
 * @extends {BaseAPI}
 */
export class MembersApi extends BaseAPI {
    /**
     * Publish MemberCreatedOrUpdated events for each member specified in the request body.
     * @summary Bulk Publish User Details
     * @param {MemberUsernameList} memberUsernameList 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public bulkPublishUserDetails(memberUsernameList: MemberUsernameList, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).bulkPublishUserDetails(memberUsernameList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Or Update Member
     * @param {MemberCreate} memberCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public createOrUpdateMember(memberCreate: MemberCreate, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).createOrUpdateMember(memberCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Latest Member Revision For Username
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public getLatestMemberRevisionForUsername(username: string, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).getLatestMemberRevisionForUsername(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Member By Email
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public getMemberByEmail(email: string, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).getMemberByEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Member Current Revision
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public getMemberCurrentRevision(memberId: string, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).getMemberCurrentRevision(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Member Specific Revision
     * @param {string} memberId 
     * @param {number} revisionNb 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public getMemberSpecificRevision(memberId: string, revisionNb: number, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).getMemberSpecificRevision(memberId, revisionNb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Members With Shipping Address
     * @param {PartialShippingAddress} partialShippingAddress 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public getMembersWithShippingAddress(partialShippingAddress: PartialShippingAddress, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).getMembersWithShippingAddress(partialShippingAddress, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Member Revisions
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public listMemberRevisions(memberId: string, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).listMemberRevisions(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Members By Ids
     * @param {MemberIdList} memberIdList 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public listMembersByIds(memberIdList: MemberIdList, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).listMembersByIds(memberIdList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Members By Usernames
     * @param {MemberUsernameList} memberUsernameList 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public listMembersByUsernames(memberUsernameList: MemberUsernameList, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).listMembersByUsernames(memberUsernameList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Park Email
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public parkEmail(memberId: string, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).parkEmail(memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search for members based on username (exact match) or email address or full name (case-insensitive substring match).
     * @summary Search
     * @param {MemberSearchIn} memberSearchIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public search(memberSearchIn: MemberSearchIn, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).search(memberSearchIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Member Details
     * @param {string} memberId 
     * @param {MemberUpdate} memberUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public updateMemberDetails(memberId: string, memberUpdate: MemberUpdate, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).updateMemberDetails(memberId, memberUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PublicApi - axios parameter creator
 * @export
 */
export const PublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Member By Username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberByUsername: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/members/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used for updating shipping details through the customer portal at zoe.com/account.  This endpoint supports partial updates of member details. Only the fields provided in the request will be updated. Fields that are not included in the request will remain unchanged.  If the request contains no updatable fields (i.e., all top-level attributes except updated_by are null or not provided), a 400 Bad Request error will be returned.
         * @summary Update Member Details
         * @param {MemberDetailsUpdate} memberDetailsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberDetails: async (memberDetailsUpdate: MemberDetailsUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'memberDetailsUpdate' is not null or undefined
            assertParamExists('updateMemberDetails', 'memberDetailsUpdate', memberDetailsUpdate)
            const localVarPath = `/public/members/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(memberDetailsUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * To be used in specific use case of free users sing-up
         * @summary Update Member First Name
         * @param {FirstNameUpdate} firstNameUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberFirstName: async (firstNameUpdate: FirstNameUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firstNameUpdate' is not null or undefined
            assertParamExists('updateMemberFirstName', 'firstNameUpdate', firstNameUpdate)
            const localVarPath = `/public/members/me/first_name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(firstNameUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicApi - functional programming interface
 * @export
 */
export const PublicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Member By Username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberByUsername(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberByUsername(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.getMemberByUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Used for updating shipping details through the customer portal at zoe.com/account.  This endpoint supports partial updates of member details. Only the fields provided in the request will be updated. Fields that are not included in the request will remain unchanged.  If the request contains no updatable fields (i.e., all top-level attributes except updated_by are null or not provided), a 400 Bad Request error will be returned.
         * @summary Update Member Details
         * @param {MemberDetailsUpdate} memberDetailsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMemberDetails(memberDetailsUpdate: MemberDetailsUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMemberDetails(memberDetailsUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.updateMemberDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * To be used in specific use case of free users sing-up
         * @summary Update Member First Name
         * @param {FirstNameUpdate} firstNameUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMemberFirstName(firstNameUpdate: FirstNameUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMemberFirstName(firstNameUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.updateMemberFirstName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublicApi - factory interface
 * @export
 */
export const PublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Member By Username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberByUsername(options?: RawAxiosRequestConfig): AxiosPromise<MemberRecord> {
            return localVarFp.getMemberByUsername(options).then((request) => request(axios, basePath));
        },
        /**
         * Used for updating shipping details through the customer portal at zoe.com/account.  This endpoint supports partial updates of member details. Only the fields provided in the request will be updated. Fields that are not included in the request will remain unchanged.  If the request contains no updatable fields (i.e., all top-level attributes except updated_by are null or not provided), a 400 Bad Request error will be returned.
         * @summary Update Member Details
         * @param {MemberDetailsUpdate} memberDetailsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberDetails(memberDetailsUpdate: MemberDetailsUpdate, options?: RawAxiosRequestConfig): AxiosPromise<MemberRecord> {
            return localVarFp.updateMemberDetails(memberDetailsUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * To be used in specific use case of free users sing-up
         * @summary Update Member First Name
         * @param {FirstNameUpdate} firstNameUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMemberFirstName(firstNameUpdate: FirstNameUpdate, options?: RawAxiosRequestConfig): AxiosPromise<MemberRecord> {
            return localVarFp.updateMemberFirstName(firstNameUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicApi - object-oriented interface
 * @export
 * @class PublicApi
 * @extends {BaseAPI}
 */
export class PublicApi extends BaseAPI {
    /**
     * 
     * @summary Get Member By Username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    public getMemberByUsername(options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).getMemberByUsername(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used for updating shipping details through the customer portal at zoe.com/account.  This endpoint supports partial updates of member details. Only the fields provided in the request will be updated. Fields that are not included in the request will remain unchanged.  If the request contains no updatable fields (i.e., all top-level attributes except updated_by are null or not provided), a 400 Bad Request error will be returned.
     * @summary Update Member Details
     * @param {MemberDetailsUpdate} memberDetailsUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    public updateMemberDetails(memberDetailsUpdate: MemberDetailsUpdate, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).updateMemberDetails(memberDetailsUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * To be used in specific use case of free users sing-up
     * @summary Update Member First Name
     * @param {FirstNameUpdate} firstNameUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    public updateMemberFirstName(firstNameUpdate: FirstNameUpdate, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).updateMemberFirstName(firstNameUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Converting an existing user to a full member. This is used when a user is independently created, and we need to create a member record, i.e. converting an *anonymous* user (user with username but no email) to a member (user with username, email address, and any other member details provided).  Email is a required field, all other fields in the request body are optional.
         * @summary Convert Existing User To Member
         * @param {string} username 
         * @param {BaseMemberDetails} baseMemberDetails 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertExistingUserToMember: async (username: string, baseMemberDetails: BaseMemberDetails, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('convertExistingUserToMember', 'username', username)
            // verify required parameter 'baseMemberDetails' is not null or undefined
            assertParamExists('convertExistingUserToMember', 'baseMemberDetails', baseMemberDetails)
            const localVarPath = `/users/{username}/convert_to_member`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseMemberDetails, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUser', 'userId', userId)
            const localVarPath = `/users/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User By Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByUsername: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getUserByUsername', 'username', username)
            const localVarPath = `/users/username/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication GoogleOpenId required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Converting an existing user to a full member. This is used when a user is independently created, and we need to create a member record, i.e. converting an *anonymous* user (user with username but no email) to a member (user with username, email address, and any other member details provided).  Email is a required field, all other fields in the request body are optional.
         * @summary Convert Existing User To Member
         * @param {string} username 
         * @param {BaseMemberDetails} baseMemberDetails 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async convertExistingUserToMember(username: string, baseMemberDetails: BaseMemberDetails, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MemberRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.convertExistingUserToMember(username, baseMemberDetails, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.convertExistingUserToMember']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get User By Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserByUsername(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserByUsername(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserByUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * Converting an existing user to a full member. This is used when a user is independently created, and we need to create a member record, i.e. converting an *anonymous* user (user with username but no email) to a member (user with username, email address, and any other member details provided).  Email is a required field, all other fields in the request body are optional.
         * @summary Convert Existing User To Member
         * @param {string} username 
         * @param {BaseMemberDetails} baseMemberDetails 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        convertExistingUserToMember(username: string, baseMemberDetails: BaseMemberDetails, options?: RawAxiosRequestConfig): AxiosPromise<MemberRecord> {
            return localVarFp.convertExistingUserToMember(username, baseMemberDetails, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(options?: RawAxiosRequestConfig): AxiosPromise<UserRecord> {
            return localVarFp.createUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserRecord> {
            return localVarFp.getUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User By Username
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByUsername(username: string, options?: RawAxiosRequestConfig): AxiosPromise<UserRecord> {
            return localVarFp.getUserByUsername(username, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * Converting an existing user to a full member. This is used when a user is independently created, and we need to create a member record, i.e. converting an *anonymous* user (user with username but no email) to a member (user with username, email address, and any other member details provided).  Email is a required field, all other fields in the request body are optional.
     * @summary Convert Existing User To Member
     * @param {string} username 
     * @param {BaseMemberDetails} baseMemberDetails 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public convertExistingUserToMember(username: string, baseMemberDetails: BaseMemberDetails, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).convertExistingUserToMember(username, baseMemberDetails, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public createUser(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).createUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUser(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User By Username
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getUserByUsername(username: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserByUsername(username, options).then((request) => request(this.axios, this.basePath));
    }
}



